export var normalizeUrl = function (url) {
    if (!url)
        return url;
    if (/^https?:\/\//i.test(url)) {
        return url;
    }
    if (/^www\./i.test(url)) {
        return "https://".concat(url);
    }
    return "https://".concat(url);
};
//# sourceMappingURL=normalizeUrl.js.mapexport var normalizeUrl = function (url) {
    if (!url)
        return url;
    if (/^https?:\/\//i.test(url)) {
        return url;
    }
    if (/^www\./i.test(url)) {
        return "https://".concat(url);
    }
    return "https://".concat(url);
};
//# sourceMappingURL=normalizeUrl.js.map